import { Component, Injector, Input } from '@angular/core';
import { SettingsService } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';

import { IntroService } from '../../services/intro.service';

@Component({
  selector: 'app-tour-start',
  templateUrl: './tour-start.component.html',
  styleUrls: ['./tour-start.component.less'],
  standalone: false
})
export class TourStartComponent {
  // @Input() onClickCallback: () => void = () => {};

  constructor(
    public settings: SettingsService,
    private modalSrv: NzModalService,
    private injector: Injector
  ) {}

  startTour() {
    this.modalSrv.closeAll();
    const intro = this.injector.get(IntroService);
    intro.show('dashboard');
  }
}
